const BASE_URL = process.env.NEXT_PUBLIC_ASSISTANT_URL;

const apiRequest = async (url, options) => {
  const response = await fetch(url, options);
  let body;

  try {
    body = await response.json();
  } catch {
    body = {};
  }

  if (!body.message) {
    body.message = response.statusText;
  }

  if (!response.ok) {
    throw new Error(body?.message || "Network Error");
  }

  return body;
};

const sendMessageSync = async (payload) => {
  const url = BASE_URL + "/send";
  const options = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return await apiRequest(url, options);
};

const transcribe = async (payload) => {
  const url = BASE_URL + "/transcribe";
  const options = {
    method: "POST",
    body: payload,
  };

  return await apiRequest(url, options);
};

const summarize = async (payload) => {
  // If no assistant URL configured, return a fallback summary
  if (!BASE_URL) {
    console.warn("NEXT_PUBLIC_ASSISTANT_URL not configured, using fallback summary");
    return { text: summarizeFallback(payload) };
  }

  const url = BASE_URL + "/summarize";
  const options = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    return await apiRequest(url, options);
  } catch (error) {
    console.warn("Summarize API failed, using fallback:", error.message);
    return { text: summarizeFallback(payload) };
  }
};

// Fallback summarizer for when the API is unavailable
const summarizeFallback = (data) => {
  if (!data) return "No data available.";

  // Handle common component types
  if (data.templates) {
    const count = data.templates.length || data.total_count || 0;
    return `Found ${count} templates.`;
  }
  if (data.campaigns) {
    const count = data.campaigns.length || data.total_count || 0;
    return `You have ${count} campaigns.`;
  }
  if (data.tasks) {
    const count = data.tasks.length || data.total_count || 0;
    return `You have ${count} tasks.`;
  }

  // Generic fallback
  return "Here is some information for you.";
};

const speechSynthesis = async (payload) => {
  const url = BASE_URL + "/speech";
  const options = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const blob = await response.blob();
  return blob;
};

export { sendMessageSync, transcribe, speechSynthesis, summarize };
